import { fabric } from 'fabric'

fabric.Object.prototype.set({
  borderColor: '#0070f0',
  cornerColor: '#fff',
  cornerStrokeColor: '#0070f0',
  borderOpacityWhenMoving: 1,
  borderScaleFactor: 2,
  cornerSize: 12,
  cornerStyle: 'circle',
  centeredScaling: false,
  centeredRotation: true,
  transparentCorners: false,
  rotatingPointOffset: 26,
  lockUniScaling: false,
  hasRotatingPoint: true,
  padding: 10,
  selectionBackgroundColor: 'rgba(255, 255, 255, 0.3)',
  objectCaching: false,
})

export const createCanvas = (nodeId: string, options = {}) => {
  return new fabric.Canvas(nodeId, {
    isDrawingMode: false,
    allowTouchScrolling: true,
    containerClass: 'canvas',
    ...options,
    preserveObjectStacking: true,
  })
}

export const createRect = (options = {}) => {
  return new fabric.Rect({
    width: 200,
    height: 200,
    fill: '#ccc',
    ...options,
  })
}

export const createIText = (options = {}) => {
  return new fabric.IText('beyond', {
    fontFamily: 'OPPOSanS-B',
    ...options,
  })
}

export const createImageFormUrl = (url: string): Promise<any> => {
  return new Promise(resolve => {
    fabric.Image.fromURL(
      url,
      (intance: any) => {
        intance.scaleToWidth(180)
        resolve(intance)
      },
      {
        crossOrigin: 'anonymous',
      }
    )
  })
}

export const propertyList = ['width', 'height', 'left', 'top', 'opacity']

export const handlerGetProperties = activeObject => {
  return propertyList.reduce((init, item) => {
    init[item] = activeObject[item]
    return init
  }, {})
}
